import script from "./UserBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserBadge.vue?vue&type=script&setup=true&lang=ts"

import "./UserBadge.vue?vue&type=style&index=0&id=61b383e0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b383e0"]])

export default __exports__